module.exports = __webpack_public_path__ + "static/img/Valores.fd8aac36.png";